export const getZapNumber = channel => channel.zapNumber || channel.ZapNumber;
